import { render, staticRenderFns } from "./ticketDialog.vue?vue&type=template&id=4d278350&scoped=true&slot-scope=scope&"
import script from "./ticketDialog.vue?vue&type=script&lang=js&"
export * from "./ticketDialog.vue?vue&type=script&lang=js&"
import style0 from "./ticketDialog.vue?vue&type=style&index=0&id=4d278350&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d278350",
  null
  
)

export default component.exports